module.exports = __webpack_public_path__ + "img/vs-bgleft.5a6fcb8c.png";